import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddAssetLayer from "../components/AddAssetLayer";

const AddAssetPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Register New Asset" />

        {/* AddAssetLayer */}
        <AddAssetLayer />
      </MasterLayout>
    </>
  );
};

export default AddAssetPage;
